// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__28s8z","inputWrap":"styles_inputWrap__1szVg","input":"styles_input__2qvo9"};